import { createContext } from 'react'
import { DesignerTasksScale } from '../types/scale'

export const DesignerTasksScaleContext = createContext<DesignerTasksScale>('normal')
